import { motion } from "motion/react";
import { Button } from "../components/button/Button";
import { useNavigate } from "react-router-dom";
import "./SummaryPage.scss"

interface SummaryPageProps {
  feedback: string;
}

export function SummaryPage({ feedback }: SummaryPageProps) {

    const navigate = useNavigate();


  return (
    <motion.div
        className="summary"
        initial={{ opacity: 0, scale: 0.9}}
        animate={{ opacity: 1, scale: 1}}
        transition={{
            opacity: { },
            scale: { type: "spring", stiffness: 200, damping: 20 },
        }}
    >
      <h3>You're interview is complete.</h3>
        <h5>Here's a quick summary of how you did.</h5>
      <div className="feedback">
        {feedback.split('\n').map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
      <div className="actions">
        <Button
            label={'Start Over'}
            buttonStyle={'primary'}
            onClick={() => {
                navigate('/');
            }}
        />
    </div>
    </motion.div>
  );
}